import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <SectionContainer
    id='sustainability-impact-environment-intro'
    moduleName='intro-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          align='center'
          nextElement='typography'>
          Establishing an environmentally sensitive <WidowBlock>corporate footprint</WidowBlock>
        </Typography>
        <Typography disableBottomPadding>
          As a purpose&#45;driven company, we strive to be good stewards of the environment in pursuit of delivering long&#45;term value to policyowners and clients. That stewardship includes taking practical steps to manage and reduce our environmental impacts by optimizing energy efficiency, water conservation, and waste management, while maintaining a consistent focus on how our working environment shapes the on&#45;campus experience.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
